import styled from 'styled-components';

export const FieldLabel = styled.div`
  font-weight: bold;
  margin-bottom:5px;
`;